import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import logo from "../assets/cograd-blue-logo.webp";
import "./AdminLogin.scss";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        setError("Invalid credentials. Please try again.");
        return;
      }
      const data = await res.json();
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_email", data.email);
      navigate("/admin/dashboard");
    } catch (err) {
      if (err instanceof TypeError) {
        setError("Cannot reach server. Please check your connection or try again later.");
      } else {
        setError("Server error. Please try again.");
      }
    }
    setLoading(false);
  };

  return (
    <div className="adm-login">
      <div className="adm-login__card">
        <img src={logo} alt="CoGrad" className="adm-login__logo" />
        <h1 className="adm-login__title">Admin Portal</h1>
        <p className="adm-login__sub">Sign in to access submissions</p>

        <form onSubmit={handleLogin} className="adm-login__form">
          <div className="adm-login__field">
            <label>Email</label>
            <input
              type="email" value={email} placeholder="admin@cograd.in"
              onChange={e => setEmail(e.target.value)} required
            />
          </div>
          <div className="adm-login__field">
            <label>Password</label>
            <div className="adm-login__pass-wrap">
              <input
                type={showPass ? "text" : "password"} value={password} placeholder="••••••••"
                onChange={e => setPassword(e.target.value)} required
              />
              <button type="button" className="adm-login__eye" onClick={() => setShowPass(p => !p)}>
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          {error && <p className="adm-login__error">{error}</p>}
          <button type="submit" className="adm-login__btn" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
